import i18n from '@/shared/i18n';
import BaseModel from "@/core/components/input-widget/BaseModel";

export default class DynamicFieldForm extends BaseModel {
  field = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
